import React, {useContext} from 'react';
import {ModalContext} from '../../../../context-providers/ModalProvider';
import {observer} from 'mobx-react';
import LockDialog from '../../../modals/LockDialog/LockDialog';
import './LockButtons.scss';
import NereusButton from '../../../NereusButton/NereusButton';
import {useSwitchChainToBase} from "../../../../hooks/useSwitchChainToBase";
import LockWithdrawDialog from "../../../modals/LockWithdrawDialog/LockWithdrawDialog";
import { ReactComponent as WalletIcon } from '../../../../assets/icons/wallet.svg';
import {contractAddresses} from "../../../../helpers/config/contracts.config";
import {ContractContext} from "../../../../context-providers/ContractsProvider";

const LockButtons: any = observer(() => {
    const { openModal } = useContext(ModalContext);

    const { lockNrsContract } = useContext(ContractContext);
    const switchChainToBase = useSwitchChainToBase();

    const handleOpenLockModal = async () => {
        try {
            await switchChainToBase()
            openModal(<LockDialog/>)
        } catch (err) {
            console.error("Lock error", err)
        }
    };
    const handleOpenWithdrawModal = async () => {
        try {
            await switchChainToBase()
            openModal(<LockWithdrawDialog/>)
        } catch (err) {
            console.error("Withdraw error", err)
        }
    };
    const handleImportTokenModal = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_watchAsset",
                params: {
                    type: "ERC20",
                    options: {
                        address: contractAddresses.base.lockNrs,
                        symbol: await lockNrsContract.read.symbol(),
                        decimals: 18,
                        image: `${window.location.origin}/assets/crypto-icons/nrs.svg`,
                    },
                },
            });
        } catch (err) {
            console.error("handleImportTokenModal error", err)
        }
    };

    return (
        <div className="LockButtons">
            <div className="flex gap-4">
                <NereusButton className="flex-1" variant="contained" onClick={handleOpenLockModal}>
                    Lock
                </NereusButton>
                <NereusButton style={{minWidth: '165px'}} className="flex-1" variant="outlined" color="secondary" onClick={handleOpenWithdrawModal}>
                    Request&nbsp;Withdrawal
                </NereusButton>
                <NereusButton style={{maxWidth: '36.5px', minWidth: '36.5px', padding: 0}} variant="outlined" color="secondary" onClick={handleImportTokenModal}>
                    <WalletIcon/>
                </NereusButton>
            </div>
        </div>
    );
});

export default LockButtons;
